export function sortByDate(list, order) {
  return list.sort(function compare(a, b) {
    var dateA = new Date(a.fecha);
    var dateB = new Date(b.fecha);

    if(order) {
      return sortDateAsc(dateA, dateB)
    } else {
      return sortDateDesc(dateA, dateB)
    }
  })
}

function sortDateAsc(date1, date2) {
  if (date1 > date2) return 1;
  if (date1 < date2) return -1;
  return 0;
};

function sortDateDesc(date1, date2) {
  if (date1 > date2) return -1;
  if (date1 < date2) return 1;
  return 0;
};
